export default __webpack_public_path__ + "static/media/nammadoors.0a03d289.png";